export const hashByValue = (val: string): number => {
    let hash = 0;
    for (let i = 0; i < val.length; i++) {
        hash = (hash << 5) - hash + val.charCodeAt(i);
        hash |= 0;
    }
    return Math.abs(hash);
};
